export default function readActions(readDB, doc, form) {
  return function () {
    if (!form) return
    readDB({paths: [{collection: 'forms', doc}, {collection: 'actions'}]}, 'actions')
  }
}
